import { motion } from "framer-motion";

// Abstract Quexify skyline: thin vertical lines of varying heights.
const BARS = [
  { x: 6, h: 46 }, { x: 12, h: 52 }, { x: 18, h: 58 },
  { x: 30, h: 74 }, { x: 36, h: 82 }, { x: 42, h: 90 }, { x: 48, h: 96 },
  { x: 60, h: 100 }, { x: 66, h: 92 }, { x: 72, h: 84 },
  { x: 84, h: 60 }, { x: 90, h: 54 }, { x: 96, h: 48 },
];

export default function Skyline({ className = "", stroke = "#0a0a0a", animate = true }) {
  return (
    <svg
      viewBox="0 0 102 104"
      preserveAspectRatio="xMidYMax meet"
      className={className}
      aria-hidden="true"
    >
      {BARS.map((b, i) => (
        <motion.line
          key={i}
          x1={b.x}
          x2={b.x}
          y1={104}
          y2={104 - b.h}
          stroke={stroke}
          strokeWidth="1.1"
          strokeLinecap="round"
          initial={animate ? { pathLength: 0, opacity: 0 } : false}
          animate={animate ? { pathLength: 1, opacity: 1 } : false}
          transition={{ duration: 1.1, delay: 0.2 + i * 0.06, ease: [0.16, 1, 0.3, 1] }}
          style={{ transformOrigin: "bottom" }}
        />
      ))}
    </svg>
  );
}
